import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-daterange', 'TIME_START', 'Laiko pradžia');
Labels.set('ui-daterange', 'TIME_END', 'Laiko pabaiga');
